import { Link } from "react-router-dom";
import {
  ArrowRight,
  LineChart,
  Wallet,
} from "lucide-react";
import Reveal from "../Reveal";
import PopularBadge from "@/components/common/PopularBadge";

const PRODUCTS = [
  {
    title: "Spot",
    desc: "Deep order books, limit & market orders, and real-time charts for every major pair.",
    href: "/trade/spot/BTC-USDT",
    icon: LineChart,
    testId: "product-spot",
  },
  {
    title: "OTC",
    desc: "Block trades with locked quotes — built for treasuries, HNIs, and large tickets.",
    href: "/otc",
    icon: Wallet,
    badge: "Popular",
    testId: "product-otc",
  },
];

export default function LandingProducts() {
  return (
    <section className="cm-landing-section bg-white" data-testid="landing-products">
      <div className="cm-container">
        <Reveal variant="fade-up" className="text-center max-w-[720px] mx-auto mb-12 lg:mb-14">
          <div className="cm-landing-section-label mb-4">Product suite</div>
          <h2 className="cm-landing-section-title">Everything you need to trade crypto</h2>
          <p className="mt-4 text-[15px] text-cm-grey leading-[1.75]">
            {/* One account across spot, peer-to-peer, and institutional desk — same security, same KYC, */}
            One account across spot and the institutional desk — same security, same KYC,
            same wallet.
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6 max-w-[960px] mx-auto">
          {PRODUCTS.map((p, i) => {
            const Icon = p.icon;
            return (
              <Reveal key={p.title} variant="fade-up" delay={i * 70}>
                <Link
                  to={p.href}
                  data-testid={p.testId}
                  className="group cm-landing-product-card h-full flex flex-col p-6 lg:p-7"
                >
                  <div className="flex items-start justify-between gap-2 mb-5">
                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-cm-blue to-cm-blue-vivid grid place-items-center shadow-[0_12px_28px_-14px_rgba(2,45,238,0.55)]">
                      <Icon size={22} className="text-white" strokeWidth={1.75} />
                    </div>
                    {p.badge && (
                      <PopularBadge testId="landing-product-otc-popular" />
                    )}
                  </div>
                  <h3 className="text-[18px] font-bold text-cm-navy group-hover:text-cm-blue transition-colors">
                    {p.title}
                  </h3>
                  <p className="mt-2 text-[13px] text-cm-grey leading-[1.7] flex-1">{p.desc}</p>
                  <span className="mt-5 inline-flex items-center gap-1.5 text-[13px] font-bold text-cm-blue">
                    Open {p.title}
                    <ArrowRight
                      size={15}
                      className="transition-transform group-hover:translate-x-0.5"
                    />
                  </span>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
